<template>
  <div class="system-box">
    <div >
      <el-form :model="form" ref="form" label-width="120px" :rules="rules" >
        <!-- <el-form-item label="旧密码：" prop="pass">
          <el-input type="password" v-model="form.pass"></el-input>
        </el-form-item> -->
        <el-form-item label="新密码：" prop="newPass">
          <el-input type="password" v-model="form.newPass"></el-input>
        </el-form-item>
        <el-form-item label="请确认新密码：" prop="checkPass">
          <el-input type="password" v-model="form.checkPass"></el-input>
        </el-form-item>
        <el-form-item label="">            
          <el-button type="primary" @click="submit()">确定修改</el-button>
          <el-button type="primary" @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {    
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newPass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form:{
        pass:'',
        newPass:'',
        checkPass:'',
      },
      rules:{
        newPass: [{ validator: validatePass, trigger: 'blur' }],
        // pass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },
      passInfo:{},
    }
  },
  methods:{
    submit() {
      this.passInfo.id = this.userInfo.id
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.passInfo.password = this.form.newPass
          this.$api._user_modify(this.passInfo).then(res => {
            res.data.status === 0?this.$message.success('修改成功！') : this._status(res.data)
            this.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
  },
}
</script>

<style scoped>
.system-box{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
</style>